// extracted by mini-css-extract-plugin
export default {"stars":"stars_stars__fMbDJ","stars__wrapper":"stars_stars__wrapper__hiDDA"};